import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// Utils
import { getGoogleCredentials } from 'util/credentials';

// Actions
import { closeMessage as closeMessageAction } from 'messages';
import { setCurrentMapZoom as setCurrentMapZoomAction } from 'current';

// Selectors
import { getBoundariesByFieldUuid } from 'boundaries/selectors';
import { getActiveFieldUuid, getActiveScript } from 'current/selectors';
import { isAppMode as isAppModeActive } from 'settings/selectors';
import { getAllMessages } from 'messages/selectors';
import { getCropIdForScript, getScriptTypeForScript } from 'scripts/selectors';
import { getProductValidationValues } from 'user/selectors';
import { getNominalWeightByCropId } from 'crops/selectors';

// Components
import BaseMap from 'mapping/BaseMap';
import MessagePanel from 'messages/MessagePanel';
import ProductRateLegend from 'mapping/legends/ProductRateLegend';
import FieldOutlineLayer from 'mapping/layers/FieldOutlineLayer';
import ManageLayer from 'mapping/layers/ManageLayer';
import ExportSelector from 'export-selector/ExportSelector';

/** Component for rendering map on Script Manager screen.  */
let ManageMapContainer = ({
  boundaries,
  closeMessage,
  cropNominalWeight,
  isAppMode,
  messages,
  productValidationValues,
  script,
  scriptType,
  setCurrentMapZoom,
  zones
}) => (
  <div className='vra-map-panel'>
    <ExportSelector />
    <div className='vra-map-wrapper'>
      <BaseMap
        bounceAtZoomLimits={!isAppMode}
        boundaries={boundaries}
        className='vra-map'
        googleCredentials={getGoogleCredentials()}
        isAppMode={isAppMode}
        onLeafletZoomEnd={ (event) => setCurrentMapZoom(event.target.getZoom())}
        showScale={true}>
        {!script && boundaries && <FieldOutlineLayer boundaryGeoJson={boundaries} /> }
        {zones
        && <ManageLayer
          cropNominalWeight={cropNominalWeight}
          productValidationValues={productValidationValues}
          script={script}
          scriptType={scriptType}
        />
        }
      </BaseMap>
      <MessagePanel closeMessage={closeMessage} isToolbarShown={false} messages={messages} />
      { zones && <ProductRateLegend /> }
    </div>
  </div>
);

ManageMapContainer.propTypes = {
  boundaries: propTypes.object,
  closeMessage: propTypes.func.isRequired,
  cropNominalWeight: propTypes.number.isRequired,
  isAppMode: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired,
  productValidationValues: propTypes.object,
  script: propTypes.object,
  scriptType: propTypes.string.isRequired,
  setCurrentMapZoom: propTypes.func.isRequired,
  zones: propTypes.object
};

ManageMapContainer = connect(
  (state) => {
    const fieldUuid = getActiveFieldUuid(state);
    const script = getActiveScript(state);
    const cropId = getCropIdForScript(state, script);
    return {
      boundaries: getBoundariesByFieldUuid(state, fieldUuid),
      cropNominalWeight: getNominalWeightByCropId(state, cropId),
      isAppMode: isAppModeActive(state),
      messages: getAllMessages(state),
      productValidationValues: getProductValidationValues(state),
      script,
      scriptType: getScriptTypeForScript(script),
      zones: script && script.zones
    };
  },
  (dispatch) => {
    return {
      closeMessage: (id) => { dispatch(closeMessageAction(id)); },
      setCurrentMapZoom: (zoom) => { dispatch(setCurrentMapZoomAction(zoom)); }
    };
  }
)(ManageMapContainer);

export default ManageMapContainer;
